import { defineEvent } from '../types/event';
export var FREE_SHIPPING_RETURNS_BUTTON_ROW_CLICK = defineEvent({
    platforms: [
        {
            name: 'Optimizely',
            alias: 'Click_on_FreeShipping_Returns_ButtonRow'
        }
    ]
});
